import { render, staticRenderFns } from "./status-with-ton.vue?vue&type=template&id=4875f600&scoped=true&"
import script from "./status-with-ton.vue?vue&type=script&lang=js&"
export * from "./status-with-ton.vue?vue&type=script&lang=js&"
import style0 from "./status-with-ton.vue?vue&type=style&index=0&id=4875f600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875f600",
  null
  
)

export default component.exports